/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CHANGE_TITLE } from "../../../../store/theming";
import { getApi } from "../../../../store/apis";
import EmptyData from "../../../../components/base/EmptyData";
import SkeletonTable from "../../../../components/base/SkeletonTable";
import { ArrowDropDown, AddCircle, GridView } from "@mui/icons-material";
import SearchDataTable from "../../../../components/base/searchDataTable";
import { Button, Grid, Pagination, Paper, Card, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiToggleSwitch, mdiToggleSwitchOffOutline } from "@mdi/js";
import day from "dayjs";

import { Menu, MenuItem } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
const ListLayananPsikolog = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const theme = useSelector((state) => state.theme.myTheme);
  const ava = useSelector((state) => state.theme.dummy);
  const [find, setFind] = useState("");
  const [loading, setLoading] = useState(true);
  const [dataSet, setData] = useState([]);
  const [emptyTxt, setEmptyTxt] = useState("");
  const [pocket, setPocket] = useState(null);
  const [formateDate, setDate] = useState(null);

  const [state, setState] = useState({
    page: 1,
    limit: 10,
    last_page: null,
    total: null,
    gender: "",
    profesi: "",
    tipeSort: null,
    asc: true,
  });
  const [form, setForm] = useState(null);
  const [dialog, setDialog] = useState(false);

  const fetchData = () => {
    setLoading(true);
    let page = `&page[size]=${state.limit}&page[number]=${state.page}`;
    let data = {
      path: `admin/konsultasi?filter[nama_konsultasi]=${find}${page}`,
    };

    dispatch(getApi(data))
      .then((data) => {
        setLoading(false);
        setData(data.data);
        setState({ ...state, total: data.total, last_page: data.last_page });
      })
      .catch((err) => {
        if (err.status == 400) {
          if (find != "") {
            setEmptyTxt(`${find} tidak cocok untuk data apapun!`);
          } else {
            setEmptyTxt(`No Data Available`);
          }
        } else {
          setEmptyTxt(`${err.status}: ${err.data.message}`);
        }
        setLoading(false);
        setData([]);
      });
  };
  const handlePage = (event, value) => {
    setState({ ...state, page: value });
  };

  const listLimit = [10, 50, 100];

  useEffect(() => {
    dispatch(CHANGE_TITLE("Konseling Setting"));
    fetchData();
  }, [state.limit, find, state.page]);

  return (
    <div>
      <Paper className="pa-3 rounded-lg mt-3">
        <h3 className="mb-3">Layanan Psikolog</h3>
        <Grid container spacing={2} className="mb-5">
          <Grid item xs={2}></Grid>
          <Grid item xs={2}>
            <Button className="capitalize rounded-lg mr-3" fullWidth color="white" style={{ height: "42px" }} variant="contained" onClick={() => navigate(`/psikotes-kategori`)}>
              <GridView className="mr-3" color="primary" />
              <p className="font-weight-bold" style={{ color: theme.primary }}>
                Kategori
              </p>
            </Button>
          </Grid>
          <Grid item xs={2}>
            <Menu
              menuClassName="mt-2"
              menuButton={
                <Card className="px-3 py-2 rounded-lg d-flex align-center justify-space-between cursor_pointer pb-2" style={{ height: "42px" }}>
                  <p className="small_txt font-weight-bold mr-3">{state.limit} Data</p>
                  <ArrowDropDown />
                </Card>
              }
              transition>
              {listLimit.map((lm, i) => (
                <MenuItem key={`limit-${i}`} onClick={() => setState({ ...state, limit: lm })}>
                  <p className="font-weight-bold txt_table">{lm} Data</p>
                </MenuItem>
              ))}
            </Menu>
          </Grid>

          <Grid item xs={3}>
            <SearchDataTable value={find} setValue={setFind} />
          </Grid>
          <Grid item xs={3}>
            <Button className="capitalize rounded-lg" fullWidth variant="contained" style={{ height: "42px" }} onClick={() => navigate(`/konseling-create`)}>
              <AddCircle className="mr-3" />
              <p className="font-weight-bold">Tambah Konsultasi</p>
            </Button>
          </Grid>
        </Grid>
        {!loading ? (
          !dataSet.length ? (
            <EmptyData />
          ) : (
            <TableContainer component="div">
              <Table aria-label="simple table" style={{ borderBottom: "none" }}>
                <TableHead>
                  <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                    <TableCell style={{ minWidth: "50px", background: theme.tertiary, borderRadius: "10px 0 0 10px" }} className="py-2">
                      <p className="font-weight-bold" style={{ color: theme.primary }}>
                        ID
                      </p>
                    </TableCell>
                    <TableCell style={{ minWidth: "150px", background: theme.tertiary }} className="py-1">
                      <p className="font-weight-bold" style={{ color: theme.primary }}>
                        Judul Konsultasi
                      </p>
                    </TableCell>
                    <TableCell style={{ minWidth: "200px", background: theme.tertiary }} className="py-1">
                      <p className="font-weight-bold" style={{ color: theme.primary }}>
                        Kategori
                      </p>
                    </TableCell>
                    <TableCell style={{ minWidth: "100px", background: theme.tertiary }} className="py-1 text-center">
                      <p className="font-weight-bold" style={{ color: theme.primary }}>
                        Durasi
                      </p>
                    </TableCell>
                    <TableCell style={{ minWidth: "130px", background: theme.tertiary }} className="py-1">
                      <p className="font-weight-bold" style={{ color: theme.primary }}>
                        Harga Normal
                      </p>
                    </TableCell>
                    <TableCell style={{ minWidth: "130px", background: theme.tertiary }} className="py-1">
                      <p className="font-weight-bold" style={{ color: theme.primary }}>
                        Harga Promo
                      </p>
                    </TableCell>
                    <TableCell style={{ minWidth: "130px", background: theme.tertiary }} className="py-1">
                      <p className="font-weight-bold" style={{ color: theme.primary }}>
                        Konselor Aktif
                      </p>
                    </TableCell>
                    <TableCell style={{ minWidth: "80px", background: theme.tertiary }} className="py-1">
                      <p className="font-weight-bold" style={{ color: theme.primary }}>
                        Status
                      </p>
                    </TableCell>
                    <TableCell style={{ minWidth: "150px", background: theme.tertiary, borderRadius: "0 10px 10px 0" }} className="py-1" align="center">
                      <p className="font-weight-bold" style={{ color: theme.primary }}>
                        Tindakan
                      </p>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataSet.map((item, i) => (
                    <TableRow key={i} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                      <TableCell>{item.id}</TableCell>
                      <TableCell>{item.nama_konsultasi}</TableCell>
                      <TableCell>{item.data_konsultasi_kategori?.name}</TableCell>
                      <TableCell>{item.durasi} Menit</TableCell>
                      <TableCell>{item.harga ? `${item.harga}` : ""} Poin</TableCell>
                      <TableCell>{item.potongan_harga ? `${item.potongan_harga} Poin` : ""}</TableCell>
                      <TableCell>{item.konselor_aktif} Orang</TableCell>
                      <TableCell>
                        <Button>{item.status === 1 ? <Icon path={mdiToggleSwitch} size={1} color={theme.primary} /> : <Icon path={mdiToggleSwitchOffOutline} size={1} />}</Button>
                      </TableCell>
                      <TableCell align="center">
                        <Button
                          variant="contained"
                          className="rounded-xl capitalize mr-3"
                          onClick={() => navigate(`/konseling/detail/${item.id}`)}
                          disableElevation
                          size="small"
                          style={{ background: theme.act_blue }}>
                          <p className="font-weight-bold" style={{ color: theme.act_lbl_blue }}>
                            Detail
                          </p>
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )
        ) : (
          <SkeletonTable txt={emptyTxt} />
        )}
        {dataSet.length ? (
          <div className="d-flex align-center justify-space-between" style={{ width: "100%" }}>
            <p className="txt_table">
              Menampilkan {state.page} - {state.limit} dari {state.total}{" "}
            </p>
            <div>
              <Pagination sx={{ padding: "0" }} count={state.last_page} page={state.page} shape="rounded" onChange={handlePage} style={{ background: "#fff" }} color="primary" />
            </div>
          </div>
        ) : (
          <></>
        )}
      </Paper>
    </div>
  );
};

export default ListLayananPsikolog;
